import { useFlags } from '@fullstory/react-hooks';
import { classNames } from '@fullstory/util/fmt';
import React from 'react';
import { Link } from 'react-router-dom';
import css from './InlineLink.module.scss';

export interface InternalLinkProps extends React.ComponentPropsWithoutRef<typeof Link> {
  /**
   * Use `inverse` on a dark background.
   */
  variant?: 'inverse';
  href?: never;
}

export const InternalLink = React.forwardRef<HTMLAnchorElement, InternalLinkProps>(
  ({ variant, className, ...props }, ref) => {
    const newFSTAColors = useFlags().featureFlags().AppNewFstaColors;
    return (
      <Link
        data-component="InternalLink"
        ref={ref}
        className={classNames(className, css.link, {
          [css.inverse]: variant === 'inverse',
          [css.newFSTAColors]: newFSTAColors,
        })}
        {...props}
      >
        {props.children}
      </Link>
    );
  },
);

InternalLink.displayName = 'InternalLink';
